import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import _ from 'underscore';
import entityComposition from '../common/classes/entityComposition';
import TextInput from '../common/controls/textInput';
import MultiPicker from '../common/controls/multiPicker';
import MultiOtherPicker from '../common/controls/multiOtherPicker';
import PDF from '../common/pdf/pdf';
const DocumentGeneral = props => {
  var _active$cloudDocument;
  const documentActions = props.documentActions,
    document = props.document,
    documentTagSelectDocumentActions = props.documentTagSelectDocumentActions,
    documentTagIndexQuery = props.documentTagIndexQuery,
    documentTagList = props.documentTagList,
    jobSelectDocument = props.jobSelectDocument,
    jobSelectDocumentActions = props.jobSelectDocumentActions;
  const active = document.active;
  const initialPathRef = useRef(((_active$cloudDocument = active.cloudDocument) === null || _active$cloudDocument === void 0 ? void 0 : _active$cloudDocument.tempPath) || null);
  useEffect(() => {
    documentTagSelectDocumentActions.serverIndex(documentTagIndexQuery);
  }, [documentTagSelectDocumentActions, documentTagIndexQuery]);
  const changeJobs = values => {
    documentActions.change(active.id, 'jobs', values);
  };
  const changeDocumentTags = values => {
    documentActions.change(active.id, 'cloudDocument/documentTags', values);
  };
  const handleChange = (key, value) => {
    documentActions.change(active.id, key, value);
  };

  /* Component rendering logic */
  let doc = 'Loading...';

  /* Only render document if it does not exist */
  const noDocumentRendered = typeof doc !== 'object';
  if (active && active.cloudDocument && active.cloudDocument.tempPath && noDocumentRendered) {
    // Use the initial path to prevent re-renders
    const pdfPath = initialPathRef.current;

    // native browser prefered, will use tqc pdf viewer for iOS mobile
    doc = /*#__PURE__*/React.createElement(PDF, {
      src: pdfPath,
      title: active.displayName,
      containerMaxHeight: "750px"
      // seemed cluttered to render the title at top and on pdf component
      // also, title will not update with change to Display Name till refresh/reload
      ,
      hideTitleIfMobile: true,
      nativeRenderer: true
    });
  } else if (active && !_.contains(_.keys(active), 'tempPath') && noDocumentRendered) {
    doc = 'Could not load document';
  }
  let tags = active.cloudDocument && active.cloudDocument.documentTags ? active.cloudDocument.documentTags : [];
  if (_.isArray(active.newTags)) {
    tags = tags.concat(active.newTags);
  }
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "text",
    field: "displayName",
    label: "Display Name",
    entity: "displayName",
    bsSize: "sm",
    value: active.displayName || '',
    className: "t-dg-display-name",
    onChange: handleChange
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(MultiPicker, {
    className: "t-dg-job",
    label: "Jobs",
    entity: jobSelectDocument,
    entityActions: jobSelectDocumentActions,
    includeSelectionsForID: active.id,
    values: active.jobs,
    labelKey: "jobNumber",
    placeholder: "Select Job",
    onChange: changeJobs
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(MultiOtherPicker, {
    className: "t-dg-document-tag",
    label: "Tags",
    options: documentTagList,
    values: tags,
    placeholder: "Select Tag",
    allowCreate: true,
    onChange: changeDocumentTags
  }))), doc);
};
export { DocumentGeneral as TestDocumentGeneral };
DocumentGeneral.propTypes = {
  document: PropTypes.shape({
    active: PropTypes.shape({
      cloudDocument: PropTypes.shape({
        documentTags: PropTypes.arrayOf(PropTypes.shape({})),
        tempPath: PropTypes.string
      }),
      displayName: PropTypes.string,
      id: PropTypes.string,
      jobs: PropTypes.arrayOf(PropTypes.shape({})),
      newTags: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }).isRequired,
  documentActions: PropTypes.shape({
    change: PropTypes.func
  }).isRequired,
  jobIndexQuery: PropTypes.shape({
    paging: PropTypes.shape({})
  }).isRequired,
  jobSelectDocument: PropTypes.shape({}).isRequired,
  jobSelectDocumentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  documentTagList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  documentTagIndexQuery: PropTypes.shape({
    paging: PropTypes.shape({})
  }).isRequired,
  documentTagSelectDocument: PropTypes.shape({}).isRequired,
  documentTagSelectDocumentActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired
};
export default entityComposition(DocumentGeneral, ['document', 'jobSelectDocument', 'documentTagSelectDocument'], {
  jobList: state => state.jobSelectDocument.list,
  jobIndexQuery: state => state.jobSelectDocument.indexQuery,
  documentTagList: state => state.documentTagSelectDocument.list,
  documentTagIndexQuery: state => state.documentTagSelectDocument.indexQuery
});